import { useRef } from 'react';

import type { AutoScrollHook } from '../data-layer/types';

/**
 * Custom hook for container ref (scroll logic moved to controllers)
 */
export default function useAutoScroll(): AutoScrollHook {
  const containerRef = useRef<HTMLDivElement>(null);

  return {
    containerRef,
  };
}
